export default __webpack_public_path__ + "static/media/wallpaper_bg6.ea0ccb54.jpg";